import {
  AngularComponentsModule,
  GoabDropdown,
  GoabDropdownItem,
  GoabDropdownOnChangeDetail,
  GoabPagination,
  GoabPaginationOnChangeDetail,
} from '@abgov/angular-components';
import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ProgressIndicatorService } from '@libs/services/progress-indicator.service';
import { CapacityReportListStateService } from '../../../../services-v2/states/capacity-report-list.state.service';

@Component({
  selector: 'app-capacity-reporting-pagination',
  imports: [
    CommonModule,
    AngularComponentsModule,
    GoabDropdown,
    GoabDropdownItem,
    GoabPagination,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './capacity-reporting-pagination.html',
  styleUrl: './capacity-reporting-pagination.scss',
})
export class CapacityReportingPagination {
  private readonly _capacityReportState = inject(
    CapacityReportListStateService
  );
  private readonly _progressIndicator = inject(ProgressIndicatorService);

  facilitiesCount = this._capacityReportState.facilitiesCount;
  perPageCountOptions = this._capacityReportState.pageCountOptions;
  perPageCount = this._capacityReportState.perPageCount;
  page = this._capacityReportState.page;

  async handlePageChange($event: GoabPaginationOnChangeDetail) {
    const currentPage = $event.page;
    if (currentPage) {
      this._progressIndicator.progressIndicatorMessage.set(
        'Loading capacity reports...'
      );
      this._progressIndicator.isProgressIndicator.set(true);
      this._capacityReportState.setPage = Number(currentPage);
      await this._capacityReportState.loadCapacityReports();
      this._progressIndicator.isProgressIndicator.set(false);
    }
  }

  async handlePerPageCountChangeEvent($event: GoabDropdownOnChangeDetail) {
    const perPageCount = Number($event.value);
    if (perPageCount) {
      this._progressIndicator.progressIndicatorMessage.set(
        'Loading capacity reports...'
      );
      this._progressIndicator.isProgressIndicator.set(true);
      this._capacityReportState.setPerPageCount = perPageCount;
      this._capacityReportState.setPage = 1;
      await this._capacityReportState.loadCapacityReports();
      this._progressIndicator.isProgressIndicator.set(false);
    }
  }
}
